<div class="container">
  <h2>Onboarding Responsibilities for <span class="highlight">{{currentUser.nick_name}}</span></h2>
  <p>Identify all users whom {{currentUser.nick_name}} will be fully or partially responsible for onboarding in this step.</p>

  <!-- No Users -->
  @if (filteredUserVaults.length === 0) {
    <div class="no-users-container">
      <div class="no-users-box">
        <img src="../../../../../assets/images/no_user_logo.svg" alt="">
        <p class="no-users-text mt-2">
          No <span class="highlight">Users</span> to show
        </p>
      </div>
    </div>
  } @else {
    <h4 class="mt-8">User ({{ filteredUserVaults.length }})</h4>
  }
  @if (filteredUserVaults.length > 0) {
    <div class="suggestions-list"[ngStyle]="{ flex: filteredUserVaults.length > 1 ? '45%' : 'none' }">
      @for (user of filteredUserVaults; track user) {
        <div class="suggestion-item">
          <app-user-avatar size="48" [name]="user" avatarClass="user-image"></app-user-avatar>
          <div class="user-details">
            <h5>{{ (user?.user?.nick_name || user?.user?.first_name) + ' ' + user?.user?.last_name | titlecase }}</h5>
            <span> {{ user?.relationship_type | titlecase }}</span>
          </div>
          <div class="member-infos--trash flex-center pointer">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon class="menu">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="deleteMember(user, true)">
                <mat-icon style="color: #eb5757; margin-right: 8px">delete</mat-icon>
                <span class="text-xs font-semibold" style="color: #eb5757">Remove</span>
              </button>
            </mat-menu>
          </div>
        </div>
      }
    </div>
  }
  <!-- Suggestions Section -->
  <h4>Suggestions ({{ filteredSuggestedVaults.length }})</h4>
  <div class="create-user">
    <button class="create-user-btn" (click)="createNewUser()">
      Create a new user
    </button>
  </div>
  <div class="suggestions-list">
    @for (user of filteredSuggestedVaults; track user) {
      <div class="suggestion-item">
        <app-user-avatar size="48" [name]="user" avatarClass="user-image"></app-user-avatar>
        <div class="user-details">
          <h5>{{ (user?.user?.nick_name || user?.user?.first_name) + ' ' + user?.user?.last_name | titlecase }}</h5>
          <span> {{ user?.relationship_type | titlecase }}</span>
        </div>
        <button (click)="addUser(user)" class="add-btn">Add</button>
      </div>
    }
  </div>
</div>
